/* Signal-exchange video for .iph-hero (/pages/kontakt hero, homepage care band).
   2026-10-10 (Stefan): starts as early as possible and has no pause button. The source is set as soon
   as the block is on screen or within one screen of it (no wait for the page load event), so the
   homepage band does not compete with the homepage hero at first paint. Still image for reduced
   motion or Save-Data; the video pauses only while off screen or while the tab is hidden. */
(() => {
  const hero = document.querySelector('.iph-hero');
  if (!hero || hero.dataset.motionReady) return;
  hero.dataset.motionReady = 'true';
  const video = hero.querySelector('.iph-hero-video');
  if (!video) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 900px)');
  const connection = navigator.connection;
  const rect = hero.getBoundingClientRect();
  let visible = rect.bottom > 0 && rect.top < innerHeight;
  let near = rect.top < innerHeight * 2;
  let failed = false;
  let variant = '';
  let revision = 0;
  video.muted = video.defaultMuted = true;

  const prefersStill = () => reduced.matches || Boolean(connection && connection.saveData);
  function fallback() {
    revision++;
    video.pause();
    video.classList.remove('is-playing');
  }
  function update() {
    if (prefersStill()) {
      fallback();
      if (video.hasAttribute('src')) {
        video.removeAttribute('src');
        video.load();
      }
      variant = '';
      failed = false;
      return;
    }
    const next = mobile.matches ? 'mobile' : 'desktop';
    if (variant !== next && (near || visible)) {
      if (variant) fallback();
      variant = next;
      failed = false;
      video.preload = 'auto';
      video.src = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    }
    if (failed || !variant) return;
    if (!visible || document.hidden) {
      video.pause();
      return;
    }
    const attempt = revision;
    const play = video.play();
    if (play) play.catch(() => {
      if (attempt !== revision || !visible || document.hidden || prefersStill()) return;
      failed = true;
      fallback();
    });
  }
  video.addEventListener('playing', () => {
    if (prefersStill() || !visible || document.hidden) {
      video.pause();
      return;
    }
    video.classList.add('is-playing');
  });
  video.addEventListener('error', () => {
    failed = true;
    fallback();
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    }).observe(hero);
    new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting || near) return;
      near = true;
      update();
    }, { rootMargin: '100% 0px' }).observe(hero);
  } else {
    near = visible = true;
  }
  reduced.addEventListener('change', update);
  mobile.addEventListener('change', update);
  if (connection && connection.addEventListener) connection.addEventListener('change', update);
  document.addEventListener('visibilitychange', update);
  update();
})();
